import React, { memo, useEffect, useState, useMemo, useRef } from 'react'
import Box from '@material-ui/core/Box'
import Skeleton from '@material-ui/lab/Skeleton'

import useMediaQuery from '@material-ui/core/useMediaQuery'
import useContainerDimensions from '../../utils/hooks/useContainerDimensions'

import getConfig from 'next/config'
const { publicRuntimeConfig } = getConfig()
const { externalBannerApi: EXTERNAL_BANNER_API, enableBanner: ENABLE_BANNER } =
  publicRuntimeConfig

const MySkeleton = ({ isMobile }) => {
  const dimention = useMemo(() => {
    return { width: isMobile ? '100%' : '100%', heigth: isMobile ? 90 : 250 }
  }, isMobile)

  const { width, heigth } = dimention

  return <Skeleton width={width} height={heigth} />
}

const LL_Tracking = () => {
  const ref = useRef(null)

  const isMobile = useMediaQuery('(max-width:375px)', { noSsr: true })
  const [isSuccess, setIsSuccess] = useState(false)

  const { width } = useContainerDimensions(ref)

  useEffect(() => {
    const fethBanner = () => {
      const size = isMobile ? 'mobile' : 'desktop'
      fetch(
        `${EXTERNAL_BANNER_API}/api/banner?device=${size}&position_page=LL_TRACKING`
      )
        .then((response) => response.json())
        .then((res) => {
          setIsSuccess(() => true)
          if (res && res.js) {
            eval(res.js)(
              'el-banner-tracking',
              `${width > 980 ? 980 - 16 : width - 16}px`
            )
          }
        })
        .catch((err) => {
          setIsSuccess(() => true)
          console.error(`LL_Tracking err`, err.message, err)
        })
    }
    if (ENABLE_BANNER) {
      fethBanner(isMobile)
    }
  }, [isMobile, width])
  console.info(`isSuccess`, isSuccess)

  return (
    ENABLE_BANNER && (
      <Box
        ref={ref}
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        marginTop={2}
        marginBottom={2}
        width="100%"
      >
        <Box id="el-banner-tracking" />
        {!isSuccess && <MySkeleton isMobile={isMobile} />}
      </Box>
    )
  )
}

export default memo(LL_Tracking)
